import React, { useEffect, useState } from "react";
import BreadcrumbStyle2 from "./../../components/Breadcrumb/BreadcrumbStyle2";
import Section from "./../../components/Section";
import DoctorDetailsSection from "./../../components/Section/DoctorDetailsSection";
import { pageTitle } from "./../../helpers/PageTitle";
import axiosInstance from "./../../utils/axiosInstance";
import { fetchDoctorProfile, imageBaseUrl } from "./../../constants/ApiConstants";
import { useParams } from "react-router-dom";
import DoctorProfileLoading from "./../../components/Section/DoctorDetailsSection/comps/DoctorProfileLoading";
import MobileSecondaryHeader from "../../components/Header/MobileSecondaryHeader";
import DoctorProfileHeader from "./comps/DoctorProfileHeader";
import { useSelector } from "react-redux";

export default function DoctorProfile() {
  pageTitle("Doctor Details");
  const id = useSelector((state) => state.appSlice.doctorData)?.id;
  const [doctorDetail, setDoctorDetail] = useState("");
  const [doctorId, setDoctorId] = useState(id);
  const [loading, setLoading] = useState(false);

  const fetchDoctorDetail = () => {
    setLoading(true);
    axiosInstance
      .post(fetchDoctorProfile, {
        doctor_id: doctorId,
      })
      .then((res) => {
        setDoctorDetail(res.data.data);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    fetchDoctorDetail();
  }, [id]);
  return (
    <>
      {doctorDetail && <DoctorProfileHeader name={doctorDetail.name} />}
      <BreadcrumbStyle2 />
      <Section bottomMd={190} bottomLg={150} bottomXl={110}>
        {loading && <DoctorProfileLoading />}
        {!loading && doctorDetail && (
          <DoctorDetailsSection infoEditable={true} imgUrl={`${imageBaseUrl}${doctorDetail.image}`} name={doctorDetail.name} department="Psychiatry Department" designation={doctorDetail.designation} description={doctorDetail.about_youself} languages={doctorDetail.languages_spoken} awards={doctorDetail?.awards} experience={doctorDetail.experience} {...doctorDetail} showSetting />
        )}
      </Section>
    </>
  );
}
